import { Component } from '@angular/core';

@Component({
  selector: 'lbl-app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss'],
})
export class RootComponent { }
